/**
 * Terug van de betaalpagina.
 *
 * De API geeft de betaalprovider de terugkeerlink mee: `/facturatie?betaling={uuid}`.
 * De terugkeer zelf zegt niet hoe de betaling afliep - ook wie afbreekt of wiens
 * betaling mislukt, komt hier terug. Het scherm vraagt daarom aan de API hoe de
 * betaling met deze uuid ervoor staat (`GET /credits/payments/{uuid}`), tot hij
 * definitief is.
 */

/** Query-parameter in de terugkeerlink. */
export const PAYMENT_RETURN_PARAM = 'betaling';

/** Een ULID, zoals elke uuid van de API. */
const ULID = /^[0-9A-HJKMNP-TV-Z]{26}$/i;

/** De betaling waarvan de gebruiker terugkomt, of `null` als het adres er geen geldige noemt. */
export function returnedPayment(params: URLSearchParams): string | null {
    const value = params.get(PAYMENT_RETURN_PARAM);

    return value !== null && ULID.test(value) ? value.toUpperCase() : null;
}
